import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { AccountsApi } from '@shared/api/rest';
import { ApiUtils } from '@shared/utils';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';
import type { AccountRequest, AccountResponse } from '@shared/api/rest/accounts';

const getAccountsEffect = createEffect((params: IQueryParams<AccountRequest>) => AccountsApi.getAccounts(params?.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<AccountResponse[]>([])
  .on(getAccountsEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getAccountsEffect.pending, (_, data) => data)
  .on(getAccountsEffect.fail, () => false)
  .on(getAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountsEffect, () => null)
  .on(getAccountsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAccountsEffect.done, () => null)
  .reset(clearEvent);

export const $initialAccountsStore = {
  events: {
    getAccounts: ApiUtils.wrapperApi(getAccountsEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
